module.exports = __webpack_public_path__ + "static/well-logo-c12c34af07b34775fe0117daedc3c581.png";